import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Page } from '../../../page/page';
import { superAdminUtilitiesRoutes } from '../super-admin-utilities.routing';

@Component({
  selector: 'app-super-admin-utilities-outlet',
  imports: [Page],
  template: `<app-page [menuItems]="menuItems" [parentRoute]="parentRoute"></app-page>`,
  styles: [],
})
export class SuperAdminUtilitiesOutlet implements OnInit {
  menuItems = superAdminUtilitiesRoutes;
  parentRoute: any;

  constructor(private readonly route: ActivatedRoute) {}

  ngOnInit(): void {
    if (this.route.routeConfig) {
      const { children, ...otherRouteAttributes } = this.route.routeConfig;
      this.parentRoute = otherRouteAttributes;
    }
  }
}
